<template>
  <div>
    <!-- Header -->
    <v-card class="pa-3 yellow lighten-3" dense>
      <v-row align="center">
        <div class="red--text text-h6 font-weight-bold ml-3">
          <v-icon left color="red darken-2">mdi-clipboard-list-outline</v-icon>
          Listado de Remitos — Entrega a Taller
        </div>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn class="mx-2" fab dark small color="black" @click="$router.push({ name: 'MainDeposito' })">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Filtros -->
    <v-card class="pa-3 yellow lighten-4" dense>
      <v-row dense align="center">
        <v-col cols="12" sm="3">
          <v-text-field dense outlined hide-details v-model="filtroOT" label="Filtrar por N° OT"
            prepend-inner-icon="mdi-magnify" clearable @keyup.enter="cargar" />
        </v-col>
        <v-col cols="auto">
          <v-btn color="success" small @click="cargar" :loading="cargando">
            <v-icon left small>mdi-magnify</v-icon>Buscar
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn outlined small @click="filtroOT = ''; cargar()">
            <v-icon left small>mdi-refresh</v-icon>Todos
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Tabla -->
    <v-card class="mt-1">
      <v-data-table dense :headers="headers" :items="remitos" :loading="cargando"
        loading-text="Cargando remitos..." no-data-text="No se encontraron remitos"
        class="elevation-1" :items-per-page="25"
        :footer-props="{ itemsPerPageText: 'Remitos por página', itemsPerPageOptions: [10, 25, 50, 100] }">

        <template v-slot:item.fecha="{ item }">
          {{ formatFecha(item.fecha) }}
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-btn icon x-small color="teal" @click="verDetalle(item)" title="Ver detalle">
            <v-icon x-small>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Componente hijo: detalle del remito -->
    <DetalleRemitoTaller :visible="showDetalle" :idreca="idrecaSeleccionado" @close="showDetalle = false" />
  </div>
</template>

<script>
import Axios from "../../axios-auth";
import DetalleRemitoTaller from "./DetalleRemitoTaller.vue";

export default {
  name: "ListadoRemitos",
  components: { DetalleRemitoTaller },

  data() {
    return {
      remitos: [],
      cargando: false,
      filtroOT: "",
      showDetalle: false,
      idrecaSeleccionado: null,
      headers: [
        { text: "Fecha", value: "fecha", },
        { text: "OT", value: "ot",},
        { text: "Nombre OT", value: "nombre" },
        { text: "Solicitó", value: "solicito" },
        { text: "Lugar", value: "lugar" },
        { text: "Preparó", value: "preparo" },
        { text: "Revisó", value: "reviso" },
        { text: "Usuario", value: "nombreUsu" },
        { text: "", value: "acciones", sortable: false },
      ],
    };
  },

  mounted() {
    this.cargar();
  },

  methods: {
    cargar() {
      this.cargando = true;
      const params = {};
      if (this.filtroOT) params.ot = this.filtroOT;

      Axios.get("/Ingenieria/ListadoRemitosTaller", { params })
        .then((r) => { this.remitos = r.data || []; })
        .catch(() => { this.remitos = []; })
        .finally(() => { this.cargando = false; });
    },

    verDetalle(item) {
      this.idrecaSeleccionado = item.idreca;
      this.showDetalle = true;
    },

    formatFecha(f) {
      if (!f) return "";
      const d = new Date(f);
      return d.toLocaleDateString("es-AR");
    },
  },
};
</script>
